// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__7YLec","imageContainer":"Avatar_imageContainer__uE83I","image":"Avatar_image__1O-qe"};